import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  IconButton,
  useTheme
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import ErrorOutlineOutlinedIcon from '@mui/icons-material/ErrorOutlineOutlined';
import PrimaryButton from '../../../components/buttons/PrimaryButton';
import SecondaryButton from '../../../components/buttons/SecondaryButton';
import ScreenReaderTitle from '../../../components/confirmation/ScreenReaderTitle';

interface VerifyAllConfirmationDialogProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  selectedCount: number;
  loading?: boolean;
}

const VerifyAllConfirmationDialog: React.FC<VerifyAllConfirmationDialogProps> = ({
  open,
  onClose,
  onConfirm,
  selectedCount,
  loading = false
}) => {
  const theme = useTheme();

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      slotProps={{ 
        backdrop: { invisible: true }, 
        paper: { style: { borderRadius: 8 } } 
      }}
      aria-labelledby="verify-all-confirmation-dialog-title"
    >
      <DialogTitle sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        position: 'relative',
        padding: theme.spacing(3),
        paddingBottom: theme.spacing(2)
      }}>
        <ErrorOutlineOutlinedIcon sx={{ fontSize: '28pt' }} />
        <ScreenReaderTitle
          accessibleTitle="Verify All Officials Confirmation"
          sanitizedTitle="verify-all-confirmation-dialog-title"
        />
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: '17px',
            top: '16px',
            color: theme.palette.grey[600],
            padding: 0
          }}
        >
          <CloseIcon sx={{ fontSize: 32 }} />
        </IconButton>
      </DialogTitle>
      
      <DialogContent sx={{ 
        padding: theme.spacing(3),
        paddingTop: 0,
        textAlign: 'center'
      }}>
        {`Please confirm that you would like to bulk verify ${selectedCount} Law Enforcement officials. This action will update their status to 'Verified'.`}
      </DialogContent>
      
      <DialogActions sx={{ 
        padding: theme.spacing(3),
        paddingTop: theme.spacing(2),
        justifyContent: 'flex-end'
      }}>
        <SecondaryButton action={onClose}>
          <span style={{ fontWeight: 600 }}>CANCEL</span>
        </SecondaryButton>
        <PrimaryButton 
          action={onConfirm} 
          loading={loading} 
          disabled={loading}
          minWidth="auto"
        >
          <span style={{ fontWeight: 600 }}>VERIFY</span>
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
};

export default VerifyAllConfirmationDialog;
